module.exports = __webpack_public_path__ + "img/logo.3ee2dcd7.png";